exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mobile__spinner-container__2Edq0{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.mobile__spinner__2Hber{color:-wix-colors-buttonsAndLinksColor}[data-layout=\"2\"] .mobile__spinner__2Hber{color:-wix-colors-mobileButtonsBackgroundColor}.mobile__container__K1HRY .mobile__box__3jUP3{display:inline-block;width:70px;height:50px}.mobile__container__K1HRY .mobile__header__18TAh{height:48px;padding:0 15px}.mobile__container__K1HRY .mobile__player-wrapper__28A-w{position:relative}.mobile__container__K1HRY .mobile__player-wrapper__28A-w .mobile__player__14Am3,.mobile__overlay-only__1R8CQ{display:-ms-flexbox;display:flex}.mobile__overlay-only__1R8CQ{position:relative}[data-view-mode=editor] .mobile__overlay-only__1R8CQ{background-color:-wix-colors-emptyPlayerBgEditor}[data-view-mode=preview] .mobile__overlay-only__1R8CQ,[data-view-mode=site] .mobile__overlay-only__1R8CQ{background-color:-wix-colors-emptyPlayerBgSite}.mobile__overlay-item-topmost__1TZxe{-ms-flex-negative:0;flex-shrink:0;position:relative}.mobile__new-mobile-ui-container__1XhG6{position:relative;background-color:#000}.mobile__real-player-placeholder__skeku{position:absolute;left:0;right:0;z-index:0}.mobile__players-list-slidable__ZTq1C{position:absolute;left:0;right:0;z-index:10}.mobile__single-item-cover__3Z3S3{position:relative}", ""]);

// exports
exports.locals = {
	"spinner-container": "mobile__spinner-container__2Edq0",
	"spinnerContainer": "mobile__spinner-container__2Edq0",
	"spinner": "mobile__spinner__2Hber",
	"container": "mobile__container__K1HRY",
	"box": "mobile__box__3jUP3",
	"header": "mobile__header__18TAh",
	"player-wrapper": "mobile__player-wrapper__28A-w",
	"playerWrapper": "mobile__player-wrapper__28A-w",
	"player": "mobile__player__14Am3",
	"overlay-only": "mobile__overlay-only__1R8CQ",
	"overlayOnly": "mobile__overlay-only__1R8CQ",
	"overlay-item-topmost": "mobile__overlay-item-topmost__1TZxe",
	"overlayItemTopmost": "mobile__overlay-item-topmost__1TZxe",
	"new-mobile-ui-container": "mobile__new-mobile-ui-container__1XhG6",
	"newMobileUiContainer": "mobile__new-mobile-ui-container__1XhG6",
	"real-player-placeholder": "mobile__real-player-placeholder__skeku",
	"realPlayerPlaceholder": "mobile__real-player-placeholder__skeku",
	"players-list-slidable": "mobile__players-list-slidable__ZTq1C",
	"playersListSlidable": "mobile__players-list-slidable__ZTq1C",
	"single-item-cover": "mobile__single-item-cover__3Z3S3",
	"singleItemCover": "mobile__single-item-cover__3Z3S3"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/views/mobile/mobile.styl
// module id = 2948
// module chunks = 1